<template>
  <!-- NOTE (TEMPLATE) to show the admin-admin dashboard -->

  <div class="animated fadeIn">
    <Dashboard />    
  </div>
</template>

<script>
 import Dashboard from "../../components/Dashboard";

export default {
  components: {Dashboard}
}
</script>